/** True when a GA4 measurement ID is present (non-empty after trim). */
export function isGoogleAnalyticsConfigured(measurementId: string | undefined | null): boolean {
  return (measurementId ?? '').trim().length > 0
}
